/**
 * Reducer for obtaining flight routes
 */
import Constants from '../constants/MainConstants';
import GeneralConstants from '../constants/GeneralConstants';
import { Map as IMap } from 'immutable';

const initialState = IMap({ reservationId: '' });

/**
 * ## auth function
 * @param {Object} state - initialState
 * @param {Object} action - type and data
 */
export default function general (state = initialState, action = null) {
  switch (action.type) {
    /**
     * ### REQUESTS (start)
     */
    case Constants.MAIN_REQUEST:
      return initialState;

    /**
     * ### SUCCESS (request ended with success)
     */
    case Constants.MAIN_SUCCESS:
      return IMap(action.data);

    case GeneralConstants.GENERAL_DATA_FETCHING_SUCCESS:
      let newData = Object.assign({}, action.data);

      if (newData.flights) {
        delete newData.flights;
      }
      if (newData.passengers) {
        delete newData.passengers;
      }
      if (newData.terms) {
        delete newData.terms;
      }
      if (newData.notifications) {
        delete newData.notifications;
      }
      if (newData.navigation) {
        delete newData.navigation;
      }

      return IMap(newData);

    /**
     * ### FAILURE (request ended with error)
     */
    case Constants.MAIN_FAILURE:
      return initialState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/GeneralReducer.js